import { Component, OnInit, OnDestroy, ViewChild, AfterContentInit, AfterViewInit, ViewContainerRef, AfterViewChecked } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SubscriptionsService } from '../../../infrastructure/services/subscriptions.service';
import { LoaderService } from '../../../infrastructure/services/loader.service';
import { AlertService, GrowlType } from '../../../infrastructure/services/alert.service';
import { Subscription } from 'rxjs';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SxContextService } from '../../../infrastructure/services/sxContext.service';
import { EliminarEntidadComponent } from '../../../helpers/components/deleteEntity/deleteEntity.component';
import { SxSecurityService } from 'app/infrastructure/services/sxSecurity.service';
import { SxSubscription } from 'app/infrastructure/model/classes/subscription.class';
import { SxTranslationService } from 'app/infrastructure/services/translation-service.service';

@Component({
  templateUrl: './detalle.subscription.component.html',
  styleUrls: ['./nuevo.subscription.component.css'],
})
export class DetalleSubscriptionComponent implements OnInit, AfterViewChecked, OnDestroy {
  @ViewChild('WIPModal') WIPModal: NgbModalRef;

  @ViewChild(EliminarEntidadComponent) eliminarEntidad: EliminarEntidadComponent;

  errors = {};
  isLoading = false;
  editandoImagen = false;
  editarContexto = false;
  descripcion: string;
  url: string;
  preset: string;
  username: string;
  password: string;
  esNuevo = false;
  errorCodigo: string = null;
  checkeandCodigo = false;
  codSubscription: string;
  codOrganization: string;
  completitud = 0;
  subscription: SxSubscription;

  // Backoffice tipos
  backofficeTipos = ['Inbroker', 'Insis'];
  backofficeTipo = 'Inbroker';

  // Subscripciones
  subsGetSubscription: Subscription;

  constructor(public loader: LoaderService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private contextService: SxContextService,
    private subscriptionsService: SubscriptionsService,
    private sxTranslationService: SxTranslationService,
    private alertService: AlertService,
    private securityService: SxSecurityService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.esNuevo = false;
      this.codSubscription = params['codsistema'];
      this.codOrganization = params['codorganizacion'];

      if (this.codSubscription === undefined) {
        this.esNuevo = true;
        this.subscription = new SxSubscription();
        this.subscription.organizationCode = this.codOrganization;
        return;
      }


      this.subsGetSubscription = this.subscriptionsService.getSubscription(this.codOrganization, this.codSubscription)
        .subscribe(data => {
          if (!data) {
            return this.router.navigateByUrl('/soc/404');
          }
          this.inicializarCampos(data);
        });
    });

  }

  ngAfterViewChecked() {
    if (this.eliminarEntidad) {
      this.eliminarEntidad.eliminado.subscribe(eliminado => this.onDelete(eliminado));
    }
  }

  ngOnDestroy() {
    if (this.subsGetSubscription) {
      this.subsGetSubscription.unsubscribe();
    }
  }

  validarCodigo() {
    this.errorCodigo = null;

    if (!this.subscription.subscriptionCode || this.subscription.subscriptionCode.length <= 0) {
      this.errorCodigo = this.sxTranslationService.getResource('AL_MENOS_1_CARACTER');
      return false;
    }

    if (this.subscription.subscriptionCode.length > 10) {
      this.errorCodigo = this.sxTranslationService.getResource('MAX_LONGITUD', { max: 10 });
      return false;
    }

    if (this.subscription.subscriptionCode === 'nuevo') {
      this.errorCodigo = this.sxTranslationService.getResource('CODIGO_INVALIDO');
      return false;
    }

    return true;
  }

  crearSistema() {
    if (!this.validarCodigo()) {

      return;
    }

    this.checkeandCodigo = true;

    // Check para ver que el codigo de sistema no esta usado
    this.subsGetSubscription = this.subscriptionsService.getSubscription(this.subscription.organizationCode, this.subscription.subscriptionCode)
      .subscribe(res => {
        this.checkeandCodigo = false;

        // Si el codigo ya existe, no puedo crear un sistema
        if (res !== null) {
          this.errorCodigo = this.sxTranslationService.getResource('CODIGO_EXISTENTE');
          return false;
        }

        // Creo el sistema
        this.subscriptionsService
          .crearDesdeUnCodigo(this.subscription.subscriptionCode, this.subscription.organizationCode)
          .then(() => {
            this.alertService.showGrowl({
              type: GrowlType.SUCCESS,
              body: 'SISTEMA_CREADO_CORRECTAMENTE',
            });
            // this.router.navigate(['/soc/organizations/'+ this.codorganizacion + "subscriptions/", this.sistema.codInstalacionV5, 'edit'])
            this.router.navigate([`soc/organizations/${this.codOrganization}/subscriptions/${this.subscription.subscriptionCode}/edit`]);
            // this.securityService.updateRoles().then(updateOK => 
            //   this.router.navigate(['/soc/backoffices/', this.sistema.codInstalacionV5, 'editar'])
            //   );
          });
      });
  }

  seleccionarBackofficeTipo(tipo) {
    if (tipo === 'Insis') {

      this.modalService.open(this.WIPModal)
        .result.then((result) => {
        }, (reason) => {
          // In case of dismiss or cancel, restore filters from backup
        });
      return;
    }
    this.backofficeTipo = tipo;
  }

  editarDescripcion(nuevoTexto) {
    this.subscription.descripcion = nuevoTexto;
    this.editarSistema({ descripcion: nuevoTexto });
  }

  editarDescripcionExt(nuevoTexto) {
    this.subscription.descripcionExt = nuevoTexto;
    this.editarSistema({ descripcionExt: nuevoTexto });
  }

  /**
   * Actualiza la Imagen del sistema en el backend
   */
  editarImagen(nuevaImagen) {

    this.subscription.imagen = nuevaImagen.imagenBase64;

    this.editarSistema({ imagen: nuevaImagen.imagenBase64 });
  }

  /////////////////////////////////////////////////////////
  // Funciones para manejar actualizaciones del Contexto //
  /////////////////////////////////////////////////////////

  confirmarEdicionContexto() {
    if (!this.esUnContextoValido()) {
      return;
    }

    this.subscription.url = this.url;
    this.subscription.preset = this.preset;
    this.subscription.username = this.username;
    this.subscription.password = this.password;

    const cambios = {
      url: this.url,
      preset: this.preset,
      username: this.username,
      password: this.password,
    };
    this.editarSistema(cambios);

    this.reiniciarErroresDeContexto();
    this.editarContexto = false;
  }

  deshacerEdicionContexto() {
    this.url = this.subscription.url;
    this.preset = this.subscription.preset;
    this.username = this.subscription.username;
    this.password = this.subscription.password;

    this.reiniciarErroresDeContexto();

    this.editarContexto = false;
  }

  onDelete(param) {
    // Reseteamos el CurrentSystem (sistema que acabamos de borrar)
    this.contextService.unloadMemory();
    this.router.navigate(['../../../'], { relativeTo: this.route });
  }

  ////////////////////////
  // Funciones privadas //
  ////////////////////////

  private inicializarCampos(data) {
    this.subscription = data;

    // Variables del contexto
    this.url = this.subscription.url;
    this.preset = this.subscription.preset;
    this.username = this.subscription.username;

    this.camposDeActualizacion(data);
  };

  private esUnContextoValido() {
    this.reiniciarErroresDeContexto();

    const esValidaUrl = this.validarRequiredVarchar(this.url, 'url');
    const esValidoPreset = this.validarRequiredVarchar(this.preset, 'preset');
    const esValidoUsername = this.validarRequiredVarchar(this.username, 'username');

    return esValidaUrl && esValidoPreset && esValidoUsername;
  }

  /**
   * Validaciones genéricas para Varchars
   *
   * @param valor El valor que será validado
   * @param campo El campo que se esta validando
   * @param presicion La longitud maxima que puede tener el valor
   */
  private validarRequiredVarchar(valor: string, campo: string, presicion: number = 255) {
    if (!valor || valor.length <= 0) {
      this.errors[campo] = this.sxTranslationService.getResource('VALOR_REQUERIDO');
      return false;
    }

    if (valor.length > presicion) {
      this.errors[campo] = this.sxTranslationService.getResource('MAX_LONGITUD', { max: presicion });
      return false;
    }

    return true;
  }

  private reiniciarErroresDeContexto() {
    this.errors['url'] = false;
    this.errors['preset'] = false;
    this.errors['username'] = false;
  }

  private editarSistema(newData) {
    // For now
    newData.organizationCode = this.subscription.organizationCode;

    this.subscriptionsService
      .editSubscription(this.subscription.organizationCode, this.subscription.subscriptionCode, newData)
      .then(res => {
        this.camposDeActualizacion(res);
        this.alertService.showGrowl({
          type: GrowlType.SUCCESS,
          body: 'EDITADO_CORRECTAMENTE',
        });
      });
  }

  private configurarSistema() {
    this.router.navigate(['../confSistema'], { relativeTo: this.route });
  }

  private camposDeActualizacion(data) {
    this.completitud = data.completitud ? JSON.parse(data.completitud).porcentaje : 0;
    this.subscription.fechaActualizacion = data.fechaActualizacion;
    this.subscription.modificado = data.modificado;
    this.subscription.urlImage = data.urlImage;
  }

  volver() {
    if (!this.esNuevo) {
      this.router.navigate(['../'], { relativeTo: this.route });
    } else {
      this.router.navigate(['../../'], { relativeTo: this.route });
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/subscription/detalle.subscription.component.ts